import React from 'react';
import ReportsView from '../components/Reports/ReportsView';

function Reports() {
  return (
    <div>
      <div className="header">
        <div>
          <h1 className="page-title">Raporlar</h1>
          <p className="page-subtitle">İşletmenizin mesaj, randevu, müşteri ve ciro performansını günlük/haftalık/aylık takip edin.</p>
        </div>
      </div>
      <ReportsView />
    </div>
  );
}

export default Reports;
